import { css } from 'aphrodite';
import * as React from 'react';
import { XIcon } from '../../../../web/components/svgs/icons/XIcon';
import { white } from '../../../styles/colors';
import { styleSheet } from '../styles';

interface IProps {
	isMobile: boolean;
	onClickToClose: () => void;
}

export const CallDetailsHeader: React.FC<IProps> = ({ isMobile, onClickToClose }) => {
	const headerMobile = isMobile ? styleSheet.headerMobile : null;
	const headerTitleMobile = isMobile ? styleSheet.headerTitleMobile : null;
	return (
		<div className={css(styleSheet.header, headerMobile)}>
			<div className={css(styleSheet.headerMain)}>
				<span className={css(styleSheet.headerTitle, headerTitleMobile)}>Call Details</span>
			</div>
			<button className={css(styleSheet.headerClose)} onClick={onClickToClose}>
				<XIcon color={white} height={12} width={12} />
			</button>
		</div>
	);
};
